/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevTerminalIcon20Solid = forwardRef('DevTerminalIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6Zm3.47 1.22a.75.75 0 0 1 1.06 0l1.897 1.896a1.25 1.25 0 0 1 0 1.768L6.53 12.78a.75.75 0 0 1-1.06-1.06L7.19 10 5.47 8.28a.75.75 0 0 1 0-1.06Zm5.28 4.28a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Z" })));
});
